var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontaineeau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}.cls-3{fill:#d61e84;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fontaine_eau",
    "data-name": "fontaine eau"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.27,47.58a.76.76,0,1,0,0-1.52A6.12,6.12,0,0,1,21.16,40,10,10,0,0,1,23,34.6a.76.76,0,1,0-1.26-.86A11.61,11.61,0,0,0,19.64,40a7.64,7.64,0,0,0,7.63,7.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 19.1,
    cy: 47.96,
    r: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.27,13.09a.78.78,0,0,0-.73.52,84.43,84.43,0,0,1-8.63,17.56A16.12,16.12,0,0,0,15.06,40a12.2,12.2,0,0,0,1.35,5.59.76.76,0,0,0,1.35-.7A10.63,10.63,0,0,1,16.58,40,14.66,14.66,0,0,1,19.17,32a82.11,82.11,0,0,0,8.1-16,92,92,0,0,0,6.1,12.87C34,30,34.69,31,35.36,32A14.57,14.57,0,0,1,38,40,10.7,10.7,0,0,1,22.2,49.36a.76.76,0,0,0-.72,1.34A12.21,12.21,0,0,0,38.41,45a9.8,9.8,0,0,0,2.59.34,9.93,9.93,0,0,0,9.92-9.92,14.14,14.14,0,0,0-2.59-7.73,56.75,56.75,0,0,1-6.6-14v0a.77.77,0,0,0-.71-.53.76.76,0,0,0-.74.52A59.54,59.54,0,0,1,34.09,27,99.64,99.64,0,0,1,28,13.61a.77.77,0,0,0-.72-.52ZM41,16.18a55.12,55.12,0,0,0,6.08,12.34,12.52,12.52,0,0,1,2.32,6.85,8.41,8.41,0,0,1-8.4,8.4,8.29,8.29,0,0,1-2-.26A12.18,12.18,0,0,0,39.48,40a16,16,0,0,0-2.86-8.78c-.56-.84-1.13-1.73-1.69-2.67A54.74,54.74,0,0,0,41,16.18Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontaineeau);
export default __webpack_public_path__ + "static/media/fontaineeau.0a00051ecb07039ebb1fe80dadb87399.svg";
export { ForwardRef as ReactComponent };